import { render } from "./Promos.vue?vue&type=template&id=5aa43ac3&ts=true"
import script from "./Promos.vue?vue&type=script&lang=ts"
export * from "./Promos.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__